import React from 'react'
import styled, { css } from 'styled-components'
import { string, func } from 'prop-types'
import { colorPalette } from '@ui-library/sl'

export const colorCodes = {
  royalBlue: '#4767F2',
}

const RadioBoxContainer = styled.div`
  ${({ stacked }) =>
    !stacked &&
    css`
      display: flex;
      justify-content: space-between;
      align-items: center;
    `}

  width: 100%;

  &:not(.controlled) {
    input:checked + label {
      border-color: ${colorCodes.royalBlue};
      color: ${colorCodes.royalBlue};
      z-index: 1;
    }
  }
`

const Label = styled.div`
  font-size: 16px;
  color: ${colorPalette.mineShaft};
  line-height: 22px;
  display: inline-block;
  font-weight: normal;
  margin-right: 9px;

  ${({ stacked }) =>
    stacked &&
    css`
      padding-bottom: 4px;
    `}
`

const Controls = styled.div`
  white-space: nowrap;
`

const RadioLabel = styled.label`
  position: relative;
  border: solid 1px ${colorPalette.greyLight};
  width: 35px;
  height: 24px;
  border-radius: 4px;
  display: inline-block;
  text-align: center;
  line-height: 22px;
  font-size: 14px;
  background-color: ${colorPalette.white};
  cursor: pointer;
`

const Yes = styled(RadioLabel)`
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
`

const No = styled(RadioLabel)`
  margin-left: -1px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
`

const RadioInput = styled.input`
  visibility: hidden;
  position: absolute;
`
const RadioBoxInput = ({ type, name, handleChange, className, position, label }) => {
  const idOui = `oui_${position}`
  const idNon = `non_${position}`

  return (
    <RadioBoxContainer className={className}>
      <Label>{label}</Label>
      <Controls data-test="seller-box-input">
        <RadioInput type={type} name={name} value="true" onChange={handleChange} id={idOui} data-test="radio-input-left" />
        <Yes htmlFor={idOui}>oui</Yes>
        <RadioInput type={type} name={name} value="false" onChange={handleChange} id={idNon} data-test="radio-input-right" />
        <No htmlFor={idNon}>non</No>
      </Controls>
    </RadioBoxContainer>
  )
}

RadioBoxInput.propTypes = {
  name: string.isRequired,
  type: string,
  className: string,
  handleChange: func,
  position: string,
  label: string,
}

RadioBoxInput.defaultProps = {
  type: 'radio',
  className: '',
  position: '',
  handleChange: () => {},
  label: '',
}

export default RadioBoxInput
